<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12"> Modul Izvješća je trenutno u razvoju </v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: 'Reports',
	components: {},
	data: function () {
		return {};
	},
	methods: {},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.reports'), href: '/#/reports', disabled: true },
		]);
	},
};
</script>

<style scoped></style>
